// extracted by mini-css-extract-plugin
export var audioPlayer = "_qo-0";